import React, { useContext } from 'react'
import ReactDOM from 'react-dom'
import { ContentInner } from '../../layout/Content'
import ModalWindow from '../../layout/modalwindow/ModalWindow'
import PercentOffBatchSetForm from '../forms/percentoff/percentoffbatchset/PercentOffBatchSetForm'
import PercentOffResetForm from '../forms/percentoff/percentoffreset/PercentOffResetForm'
import UtilitiesInnerStyle from './css/UtilitiesInnerStyle'
import POListController from '../purchaseorder/polist/POListController'
import { appContext } from '../../../App'

function UtilitiesInner() {
  const app = useContext(appContext)
  const setContent = app.content[1]

  const cb = (button) => {
    ReactDOM.unmountComponentAtNode(document.getElementById('modal-form-container'))
  }

  const onClickPercentOffBatchSetButton = (e) => {
    ReactDOM.render (
      <ModalWindow
        id='mw-parent'
        width={60}
        height={70}
        header='Set Item Percent Off by batch'
        footer={null}>
        <PercentOffBatchSetForm app={app} cb={cb} />
      </ModalWindow>,
      document.getElementById('modal-form-container')
    )
  }

  const onClickResetPercentOffButton = (e) => {
    ReactDOM.render (
      <ModalWindow
        id='mw-parent'
        width={60}
        height={70}
        header='Reset Item Percent Off'
        footer={null}>
        <PercentOffResetForm app={app} cb={cb}/>
      </ModalWindow>,
      document.getElementById('modal-form-container')
    )
  }

  return (
    <ContentInner>
      <div className='utilities-container'>
        {/** Purchase Order **/}
        <button id='po-button' onClick={(e) => { setContent(<POListController />) }} className='utilities-item-wrapper'>
          <div className='utilities-item-title'>Purchase Order</div>
          <div className='utilities-item-description'>
            Generate/Print/Manage Purchase Orders...
          </div>
        </button>

        {/** Percent Off Batch Set **/}
        <button id='percent-off-batch-set-button'
          onClick={onClickPercentOffBatchSetButton}
          className='utilities-item-wrapper'>
          <div className='utilities-item-title'>Percent Off Batch Set</div>
          <div className='utilities-item-description'>
            Set item's percent off all at once
          </div>
        </button>

        {/** Reset Percent Off Batch's **/}
        <button id='reset-percent-off-button'
          onClick={onClickResetPercentOffButton}
          className='utilities-item-wrapper'>
          <div className='utilities-item-title'>Reset Percent Off</div>
          <div className='utilities-item-description'>
            Reset all selected item's percent off fields
          </div>
        </button>
      </div>
      <UtilitiesInnerStyle signed_in={app.client.signed_in}/>
    </ContentInner>
  )
}

export default React.memo(UtilitiesInner)
